<template>
  <v-dialog v-model="downloadConfirmDialogVisible" persistent width="700">
    <customDialog>
      <template v-slot:title>
        {{tmb('titleCreateVideo')}}
        <!-- <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="downloadConfirmDialogVisible = false">
        </button> -->
      </template>
      <template v-slot:body>
        <v-col class="ma-0 pa-0" cols="12">
          <v-col class="ma-0 pa-0 pt-5 pb-7 pl-7 pr-7 content" cols="12" style="height:300px;">
            <v-col class="ma-0 pa-0 mb-4 text-left" cols="12">{{tmb('isOkCreate')}}</v-col>
            <v-row class="ma-0 pa-0 mb-6" align="center">
              <v-col class="ma-0 pa-0 pr-2 text-left" cols="2">{{tmb('device')}}</v-col>
              <v-col class="ma-0 pa-0 text-left" cols="10">{{streamData.cameraName}}</v-col>
            </v-row>
            <v-row class="ma-0 pa-0 mb-6" align="center">
              <v-col class="ma-0 pa-0 pr-2 text-left" cols="2">{{tmb('durationDateTime')}}</v-col>
              <v-col class="ma-0 pa-0 text-left" cols="10">
                {{params.beginTime.replace('T', ' ').substring(0,16) + ' ~ ' + params.endingTime.replace('T', ' ').substring(0,16)}}
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 mb-6" align="center">
              <v-col class="ma-0 pa-0 pr-2 text-left" cols="2">{{tmb('durationTimeColon')}}</v-col>
              <v-col class="ma-0 pa-0 text-left" cols="10">{{downloadTime + '分'}}</v-col>
            </v-row>
            <v-row class="ma-0 pa-0 mb-6" align="center">
              <v-col class="ma-0 pa-0 pr-2 text-left" cols="2">{{tmb('fileName')}}</v-col>
              <v-col class="ma-0 pa-0 text-left" cols="10">{{dataName}}</v-col>
            </v-row>
          </v-col>
          <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
            <v-btn class="ma-0 pa-0" id="grey_btn" v-if="!loading" @click="downloadConfirmDialogVisible = false"
                   width="8rem" height="2rem">{{t('cancel')}}</v-btn>
            <v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="confirm" :loading="loading"
                   width="8rem" height="2rem">{{tmb('create')}}</v-btn>
          </v-row>
        </v-col>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
  props: {
    dialogVisible: Boolean,
    params: Object,
    streamData: Object,
    downloadTime: String,
    dataName: String
  },
  components: {
    customDialog
  },
  mixins: [mixin.common],
  data: () => ({
    downloadConfirmDialogVisible: false,
    loading: false,
  }),
  watch: {
    dialogVisible: function(item) {
      this.downloadConfirmDialogVisible = item;
    },
    downloadConfirmDialogVisible: function(item) {
      this.$emit('visible', item);
    },
  },
  mounted() {
    
  },
  methods: {
    confirm() {
      this.loading = true;
      this.networkController.makeRecodedVideo(this.params,  this.streamData.contractCd, this.streamData.portNo).then((res) => {
        this.loading = false;
        this.info();
        this.$emit('success', true)
        this.downloadConfirmDialogVisible = false;
      }).catch(error => {
        // status가 400번인 경우에만 에러 메시지를 보여준다.
        if (error && error.response && error.response.status === 400) {
          this.showToastMessage(this.tmb('requestFail'));
          this.loading = false;
          this.downloadConfirmDialogVisible = false;
          return;
        }
        // 시간 초과일 때는 에러 메시지를 보여주지 않는다.
        // this.showToastMessage(this.tmb('serverTimeoutExpired'));
        this.loading = false;
        this.info();
        this.$emit('success', false);
        this.downloadConfirmDialogVisible = false;
      });
    },
    info() {
      this.$dialog.confirm({
        title: '',
        text: this.tmb('msgConfirm'),
        actions: {
          true: { color: 'white', text: 'OK', handle: () => {

            }
          }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/* .content {
  font-weight: bold;
} */
.v-list {
  background: #171921;
  border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
}
</style>